<template>
    <div v-show="myConfig.visible">
        <Input
            ref="myControl"
            v-model="label"
            :size="myConfig.size"
            :placeholder="myConfig.placeholder"
            :readonly="!myConfig.allowInput"
            :disabled="myConfig.readOnly"
            @on-focus="parser"
            @on-blur="_setFatherValue"
            style="width:100%"
        >
            <span v-if="showPrefix" slot="prepend">
                <CommonIcon :type="myConfig.prefix" size="20" />
            </span>
            <span v-if="showUnit" slot="append">{{myConfig.unit}}</span>
            <div v-if="myConfig.unitCustom" slot="append" :style="'min-width:' + myConfig.unitWidth + 'px'">
                <NumberRangeExpand  :render="myConfig.unitRender"  />
            </div>
        </Input>
    </div>
</template>
<script>
import Base from '@/components/base/controlbase.vue';
import NumberRangeExpand from './append.js';
export default {
    name: 'numberbox',
    extends: Base,
    data() {
        return {
            myConfig: {
                max: Infinity,
                min: -Infinity,
                precision: 0,
                format: 'n0',
                defaultValue: 0,
                allowInput: true,
                unit: '',
                prefix: '',
                showPrefix: false,
                boundaryValue: true,
                unitCustom:false,
                unitWidth: 80
            },
            showUnit: false,
            showPrefix: false,
            label: '',
            value: '',
            oldValue: '',
        };
    },
    props: {
        fatherValue: {
            type: [String, Number],
            default: '',
        },
    },
    components:{
        NumberRangeExpand
    },
    methods: {
        fatherValueToValue(value) {
            let obj = this.myConfig.defaultValue;
            if (this.config.defaultValue != undefined) {
                obj = this.config.defaultValue;
            }
            if (Number(value) || Number(value) === 0) {
                obj = Number(value);
            }
            if (value === '' && this.config.defaultValue === '') {
                obj = value;
            }
            return obj;
        },
        valueToFatherValue() {
            let para = {};
            para.value = this.value + '';
            return para;
        },
        _setFatherValue() {
            if (this.label === '' && this.myConfig.defaultValue === '') {
                this.value = '';
            } else {
                if (!Number(this.label) && Number(this.label) !== 0) {
                    this.label = this.myConfig.defaultValue;
                }
                if (this.myConfig.boundaryValue) {
                    if (Number(this.label) < this.myConfig.min) {
                        this.alert('输入值不能小于' + this.myConfig.min);
                        this.label = this.myConfig.min;
                    }
                    if (Number(this.label) > this.myConfig.max) {
                        this.alert('输入值不能大于' + this.myConfig.max);
                        this.label = this.myConfig.max;
                    }
                } else {
                    if (Number(this.label) <= this.myConfig.min) {
                        this.alert('输入值不能小于等于' + this.myConfig.min);
                        this.setFatherValueFail();
                        return false;
                    }
                    if (Number(this.label) >= this.myConfig.max) {
                        this.alert('输入值不能大于等于' + this.myConfig.max);
                        this.setFatherValueFail();
                        return false;
                    }
                }

                this.value = this.$Method.precisionNumber(
                    this.label,
                    this.myConfig.format,
                );
                if (this.myConfig.proportional) {
                    if (Number(this.label) < 1) {
                        this.value = this.$Method.precisionNumber(
                            this.label,
                            'p2',
                        );
                    }
                }
                if (this.label === '' && this.myConfig.defaultValue === '') {
                    this.value = this.label;
                }
            }

            this.setFatherValue();
        },
        setFatherValueSuccess(para) {
            this.label = this.$Method.formatNumber(
                this.value,
                this.myConfig.format,
            );
            if (this.myConfig.proportional) {
                if (Number(this.value) < 1) {
                    this.label = this.$Method.formatNumber(this.label, 'p2');
                }
            }
            if (this.value === '' && this.myConfig.defaultValue === '') {
                this.label = this.value;
            }
            this.$emit('input', para);
        },
        setFatherValueFail() {
            this.label = this.$Method.formatNumber(
                this.oldValue,
                this.myConfig.format,
            );
            this.value = this.oldValue;
            if (this.myConfig.proportional) {
                if (Number(this.oldValue) < 1) {
                    this.label = this.$Method.formatNumber(this.oldValue, 'p2');
                }
            }
            if (this.oldValue === '' && this.myConfig.defaultValue === '') {
                this.label = this.oldValue;
            }
        },
        customInit() {
            if (this.config.min !== undefined) {
                if (this.myConfig.boundaryValue) {
                    this.myConfig.defaultValue = this.config.min;
                } else {
                    this.myConfig.defaultValue = '';
                }
            }
            if (this.myConfig.unitRender) { 
                this.myConfig.unitCustom = true;
            } else {
                this.myConfig.unitCustom = false; 
            }
            if (this.myConfig.format && this.myConfig.format.length > 1) {
                this.myConfig.precision = Number(this.myConfig.format[1]);
                if (this.myConfig.showPrefix) {
                    if (!this.myConfig.prefix) {
                        if (this.myConfig.format.startsWith('c')) {
                            this.showPrefix = true;
                            this.myConfig.prefix = 'logo-yen';
                        }
                    } else {
                        this.showPrefix = false;
                    }
                } else {
                    this.showPrefix = false;
                }

                if (this.myConfig.unit) {
                    this.showUnit = true;
                }

                this.label = this.$Method.formatNumber(
                    this.value,
                    this.myConfig.format,
                );
                if (this.myConfig.proportional) {
                    if (Number(this.value) < 1) {
                        this.label = this.$Method.formatNumber(
                            this.value,
                            'p2',
                        );
                    }
                }
                if (this.value === '' && this.myConfig.defaultValue === '') {
                    this.label = this.value;
                }
            }
        },

        formatter(value) {
            if (this.myConfig.format) {
                if (Number(value) || value === 0) {
                    return this.$Method.formatNumber(
                        value,
                        this.myConfig.format,
                    );
                } else {
                    return value;
                }
            }
        },
        parser() {
            this.label = this.value;
        },
        watchCustomFatherValue() {
            this.label = this.getLabel();
        },
        getLabel() {
            let label = this.$Method.formatNumber(
                this.value,
                this.myConfig.format,
            );
            if (this.myConfig.proportional) {
                if (Number(this.value) < 1) {
                    label = this.$Method.formatNumber(this.value, 'p2');
                }
            }
            if (this.value === '' && this.myConfig.defaultValue === '') {
                label = this.value;
            }
            return label;
        },
        setFocus(value) {
            if (value) {
                this.$refs.myControl.focus();
            } else {
                this.$refs.myControl.blur();
            }
        }
    },
    beforeDestroy() {
        if (this.myConfig.place === 'grid') {
            if (this.label !== this.getLabel()) {
                this.setFatherValue();
            }
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/components/numberbox/numberbox.vue